import { Pipe, PipeTransform } from '@angular/core';
import { objectContainsTerm } from 'src/app/shared/utils/object-search.util';

@Pipe({
  standalone: false,
  name: 'filter',
  pure: false,
})
export class SearchFilterPipe implements PipeTransform {
  /**
   * @param items object from array
   * @param term term's search
   * @param excludes array of strings which will ignored during search
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform<T = any>(items: T[], term: string, excludes: unknown[] = []): T[] {
    if (!term || !items?.length) return items;

    return SearchFilterPipe.filter(items, term, excludes);
  }

  /**
   *
   * @param items List of items to filter
   * @param term  a string term to compare with every property of the list
   * @param excludes List of keys which will be ignored during search
   *
   */
  static filter<T>(items: T[], term: string, excludes: unknown[]): T[] {
    if (!term || !items?.length) return items;
    return items.filter((item) => {
      if (typeof item === 'object' && item !== null) {
        return objectContainsTerm(item, term);
      }
      return String(item).toLowerCase().includes(term.toLowerCase());
    });
  }
}
